import {
  CircularProgress,
} from "@mui/material";
import { Theme, useTheme } from '@mui/material/styles'
import { createStyles, makeStyles } from '@mui/styles';
import { useEffect, useState } from "react";
import ResponsiveDrawer from "../../components/ClippedResponsiveDrawer";
import GetDriverNotes from "../../utils/GetDriverNotes";
import { useLocalStorage } from "../../utils/LocalStorageHook";
import TableAbstraction from "../../componentUtils/TableAbstraction"

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    centerDiv: {
      textAlign: "center",
    },
    root: {
      padding: theme.spacing(2),
      marginBottom: theme.spacing(2),
    },
    rootContainer: {
      [theme.breakpoints.down("md")]: {
        padding: 0,
        paddingTop: theme.spacing(1),
      },
    },
    tokenBlock: {
      width: "500px",
      overflowWrap: "break-word",
    },
    typography: {
      paddingTop: theme.spacing(2),
      paddingBottom: theme.spacing(1),
    },
  })
);

export function VendPrimeNotes() {
  const classes = useStyles();
  const [driverNotes, setDriverNotes] = useState<any[]>([]);
  const [salesOrg] = useLocalStorage("SETTINGS.salesOrg", "");
  const [wasError, setWasError] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (driverNotes.length > 0) return;
    GetDriverNotes(salesOrg)
      .then((v) => {
        setIsLoading(false)
        v.notes && v.notes.length > 0 && setDriverNotes(v.notes);
      })
      .catch((_) => {setIsLoading(false);setWasError(true)});
  }, []);

  const hasEffective = driverNotes.find((v) => v.effectiveDate);
  const hasExpiration = driverNotes.find((v) => v.expirationDate);

  return (
    <ResponsiveDrawer
      title="Driver Notes"
    >
      <div className={classes.rootContainer}>
        {!wasError && !isLoading && (
          <TableAbstraction
            settingsKey="VP_NTS"
            options={{
              draggableColumns: {
                enabled: true,
              },
              serverSide: true,
              selectableRows: "none",
            }}
            title="Driver Notes"
            columns={[
              {
                label: "Asset #",
                name: "assetNum",
                options: {
                  filter: false,
                },
              },
              {
                label: "NoteType",
                name: "noteType",
                options: {
                  filter: false,
                },
              },
              {
                label: "Customer Name",
                name: "customerName",
                options: {
                  filter: false,
                },
              },
              {
                label: "Customer #",
                name: "customerNum",
                options: {
                  filter: false,
                },
              },
              {
                label: "Effective Date",
                name: "effectiveDate",
                options: {
                  display: hasEffective,
                  filter: false,
                },
              },
              {
                label: "Expires On",
                name: "expirationDate",
                options: {
                  display: hasExpiration,
                  filter: false,
                },
              },
              {
                label: "Requested By",
                name: "requestedBy",
                options: {
                  filter: false,
                },
              },
              {
                label: "Note",
                name: "note",
                options: {
                  filter: false,
                },
              },
            ]}
            data={driverNotes}
          />
        )
           }
        { isLoading && (
          <div className={classes.centerDiv}>
            <CircularProgress color="primary" />
          </div>
        ) }
      {
      wasError && (
        <div>Failed to load driver notes</div>
      )
      }

        
      </div>
    </ResponsiveDrawer>
  );
}